var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OnlineUsers.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-28625847\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OnlineUsers.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/Chatroom/ChatSidePanelWidgets/OnlineUsers.vue
// module id = 364
// module chunks = 1